import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { DLiquidacionRecibo } from '@dian-api/recibo-pago490';
import { DContextoMuisca } from '@dian/core';
import { DInfoResumenFormulario, DVersionRutaFormato } from "@dian/api-formulario";

@Injectable()
export class GeneralService {
  constructor() {}

  private crearBorrador = new Subject<any>();
  private editarFormulario = new Subject<any>();
  private corregirFormulario = new Subject<any>();
  private pagarFormulario = new Subject<any>();
  private copiarFormulario = new Subject<any>();
  public crearBorrador$ = this.crearBorrador.asObservable();
  public editarFormulario$ = this.editarFormulario.asObservable();
  public corregirFormulario$ = this.corregirFormulario.asObservable();
  public pagarFormulario$ = this.pagarFormulario.asObservable();
  public copiarFormulario$ = this.copiarFormulario.asObservable();
  private fraccionAnio = new Subject<any>();
  public fraccionAnio$ = this.fraccionAnio.asObservable();

  private pagoCuotas = new Subject<any>();
  public pagoCuotas$ = this.pagoCuotas.asObservable();

  private datosRespuesta = new Subject<DContextoMuisca>();
  private datosUsuario: DContextoMuisca;
  public datosRespuesta$ = this.datosRespuesta.asObservable();


  private datosReciboPago = new Subject<{contexto: DContextoMuisca; tieneFirmaElectronica: boolean; liquidacion: DLiquidacionRecibo; fecha?: string; mensajeAntesGuardar?: string; pagoPSE: boolean;}>();
  public datosReciboPago$ = this.datosReciboPago.asObservable();
  

  private datosFirmaYTipoContribuyente = new Subject<{esFirmaElectronica: boolean; granContribuyente: boolean}>();
  public datosFirmaYTipoContribuyente$ = this.datosFirmaYTipoContribuyente.asObservable();
  private firmaYTipoContribuyente: {esFirmaElectronica: boolean; granContribuyente: boolean};

  private versionesRuta = new Subject<DVersionRutaFormato[]>();
  public versionesRuta$ = this.versionesRuta.asObservable();
  private versiones : DVersionRutaFormato[];


  private sugerida = new Subject<any>();
  public sugerida$ = this.sugerida.asObservable();
  private _sugerida : any;

  private devoluciones = new Subject<any>();
  public devoluciones$ = this.devoluciones.asObservable();
  private _devoluciones : any;
  private devolucioneshref = new Subject<any>();
  private requestEnvio = new String();


  enviarSugerida(sugerida: any) {
    this._sugerida = sugerida;
    this.sugerida.next(sugerida);
  }

  obtenerSugerida(){
    return this._sugerida;
  }

  getDevoluciones()
  {
    return this._devoluciones;
  }
  setDevoluciones(devoluciones: any)
  {
    this._devoluciones = devoluciones;
    this.devoluciones.next(devoluciones);
  }
  getDevolucioneshref()
  {
    return this.devolucioneshref;
  }
  setDevolucioneshref(devolucioneshref: any)
  {
    this.devolucioneshref = devolucioneshref;
  }
  getrequestEnvio()
  {
    if(!this.requestEnvio)
    {
      const contexto = <DContextoMuisca>JSON.parse(sessionStorage.getItem('DIAN-MUISCATK'));
      this.requestEnvio = contexto.token.idToken;
      if(!this.requestEnvio)this.requestEnvio=this.datosUsuario.token.idToken;
    }
    return this.requestEnvio;
  }
  setrequestEnvio(requestEnvio: string)
  {
    this.requestEnvio = requestEnvio;
  }
  
  enviarVersionesRuta(versiones: DVersionRutaFormato[]): void {
    this.versiones = versiones;
    this.versionesRuta.next(versiones);
  }
  getVersionesRuta() {
    return this.versiones;
  }

  setDatosFirmaYGranContribuyente(datos) {
    this.datosFirmaYTipoContribuyente.next(datos);
    this.firmaYTipoContribuyente = datos;
  }

  getDatosFirmaYGranContribuyente(){
    return this.firmaYTipoContribuyente;
  }

  setDatosUsuario(datos) {
    this.datosUsuario = datos;
    this.datosRespuesta.next(datos);
  }

  getDatosUsuario(){
    return this.datosUsuario;
  }

  enviarCrearBorrador(mensaje: any): void {
    this.crearBorrador.next(mensaje);
  }

  enviarEditarFormulario(data: any): void {
    this.editarFormulario.next(data);
  }

  enviarCorregirFormulario(data: any): void {
    this.corregirFormulario.next(data);
  }

  enviarPagarFormulario(data):void{
    this.pagarFormulario.next(data);
  }
  enviarFraccioAnio(mensaje: any): void {
    this.fraccionAnio.next(mensaje);
  }

  enviarPagoCuotas(mensaje: any): void {
    this.pagoCuotas.next(mensaje);
  }
  
  enviarCopiarFormulario(data:DInfoResumenFormulario):void{
    this.copiarFormulario.next(data);
  }

  enviarDatosReciboPago(datos: {contexto: DContextoMuisca; tieneFirmaElectronica: boolean; liquidacion: DLiquidacionRecibo; fecha?: string; mensajeAntesGuardar?: string; pagoPSE: boolean;}) {
    this.datosReciboPago.next(datos);
  }

}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/services/general.service.ts